'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-composer', {
      url: '/mail/composer/:id',
      template: '<mail-composer></mail-composer>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/composer/mail-composer.routes.js